import {css, html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/TextInput/TextInput.js'
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import '@isceco/widget-library2/basic-elements/Form/Form.js'
import '@isceco/widget-library2/basic-elements/ModalDialog/ModalDialog.js'
import WebComponent from '../../WebComponent.js'
import I18n from '../../i18n.js'
import AdminService from '../../services/AdminService.js'

export default class Ml extends WebComponent {

  static get EVENT_KEYS() {
    return {
      RELOAD_TRIGGERED: 'parameter-reload-triggered'
    }
  }

  get css() {
    return css`
      isceco-title:first-of-type {
        display: block;
        margin-top: -20px;
        margin-bottom: -15px;
      }
    `
  }

  get translationFile() {
    return './views/Admin/i18n.json'
  }

  constructor() {
    super()
    this.adminService = new AdminService()
    this.mlParameter = {
      activated : false
    }
  }

  connectedCallback() {
    super.connectedCallback()

    this._refresh = () => {
      send(Ml.EVENT_KEYS.RELOAD_TRIGGERED)
      this._loadData()
    }
    document.addEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)

    this._loadData()
  }

  disconnectedCallback() {
    document.removeEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._refresh)
  }

  _loadData() {
    Promise.all([
      this.adminService.list('ml-parameter')])
      .then(([mlParameter]) => {
        if(mlParameter.length > 0) {
          this.mlParameter.activated = mlParameter[0].activated
        }
        this.render()
      }).catch(_ => this.reload())
  }

  getTemplate() {
    return html `
     <isceco-title text="${this.i18n.translate('admin.ml.parameter.header')}">
     </isceco-title>
     <isceco-checkbox
       label="${this.i18n.translate('admin.ml.parameter.activate.ml')}""
       @change="${e => this._save(e)}"
       .value="${this.mlParameter.activated}">
     </isceco-checkbox>
     <isceco-button
       variant="warning"
       style="margin-top: 15px; width: 200px"
       ?disabled="${!this.mlParameter.activated}"
       style="margin-top: 15px"
       text="${this.i18n.translate('admin.ml.parameter.train.btn')}"
       @click="${e => this._train(e)}">
     </isceco-button>
     <isceco-button
       variant="primary"
       ?disabled="${!this.mlParameter.activated}"
       style="margin-top: 15px; width: 200px"
       text="${this.i18n.translate('admin.ml.parameter.prediction.btn')}"
       @click="${e => this._makePrediction(e)}">
     </isceco-button>
    `
  }

  _save(event) {
    this.mlParameter.activated = event.detail.value
    this.adminService.create(this.mlParameter,"/ml-parameter-activate").then(response => {
      if(response.status === 200) {
        showAlert(this.i18n.translate('admin.ml.parameter.save.success'), '', 'success')
      } else {
        showAlert(this.i18n.translate('admin.ml.parameter.save.error'), '', 'error')
      }

      this._refresh()
    })
  }

  _train(event) {
    this.adminService.create(this.mlParameter,"/ml-train").then(response => {
      if(response.status === 200 && response.trained) {
        showAlert(this.i18n.translate('admin.ml.parameter.train.success'), '', 'success')
      } else {
        showAlert(this.i18n.translate(response.trained ? 'admin.ml.parameter.train.error' : 'admin.ml.parameter.train.error.nodata'), '', 'error')
      }
    })
  }

  _makePrediction(event) {
    this.adminService.create(this.mlParameter,"/ml-calculate").then(response => {
      if(response.status === 200 && response.predicted) {
        showAlert(this.i18n.translate('admin.ml.parameter.calculate.success'), '', 'success')
      } else {
        showAlert(this.i18n.translate(response.predicted ? 'admin.ml.parameter.calculate.error' : 'admin.ml.parameter.train.error'), '', 'error')
      }
    })
  }
}
customElements.define('gasmonitoring-frontend-admin-ml', Ml)
